import { defa }    from 'defa-object';
import Customer    from 'scripts/defa/customers/model-customer';
import LegacyUnits from 'scripts/defa/legacy/collection-legacy-units';
import Model       from 'scripts/poppet/model';

/**
 * defa.models.LegacyUser
 * The DEFA LegacyUser model.
 * @version 1.2.2
 */

const channelUser = Bb.Radio.channel( 'user' ),
	channel     = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	auth: apiHost + '/legacy/migration/unit/login',
	user: apiHost + '/legacy/migration/user',
};

const LegacyUser = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.auth,
	
	defaults: {
		user    : '',
		password: '',
		units   : !1,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks if this model has one or more units.
	 * @void
	 */
	hasUnits: function () {
		return ( this.get( 'units' ) && this.get( 'units' ).length >= 1 );
	},
	
	/**
	 * Generates an advanced User model for the end user.
	 * @void
	 */
	generateUser: function ( options ) {
		let self = this;
		
		this.set( options ); // set user and password for later
		
		$.ajax( {
			 url        : api.user,
			 method     : 'POST',
			 contentType: 'application/json',
			 data       : JSON.stringify( {
				 transientUsername: options.user,
				 transientPassword: options.password,
			 } ),
		 } )
		 .done( function ( response ) {
			
			 if ( response.customers ) {
				 channel.request( 'customers' ).add( response.customers, { merge: true } );
			 }
			
			 if ( response.mapUsersCustomers ) {
				 _.extend( defa.vars.mapUsersCustomers, response.mapUsersCustomers );
			 }
			
			 if ( response.phoneNumbers ) {
				 channel.request( 'phoneNumbers' ).add( response.phoneNumbers, { merge: true } );
			 }
			
			 if ( response.units ) {
				 channel.request( 'units' ).add( response.units, { merge: true } );
			 }
			
			 if ( response.user ) {
				 channelUser.request( 'model' ).set( response.user ); // the user should now be logged in
			 }
			
			 // trigger different responses based on the transientCreated
			 let tEvent = ( response.transientCreated )
						  ? 'user:created'
						  : 'user:found';
			
			 self.trigger( tEvent );
		 } )
		 .fail( function ( response ) {
			 self.trigger( 'error', self, response );
		 } );
	},
	
	/**
	 * Attempts to authenticate a legacy user.
	 * @param {object} options  An object containing both a username and a password param.
	 * @void
	 */
	authenticate: function ( options ) {
		
		options = options || {};
		
		let self = this,
			data = {
				user    : options.user || this.get( 'user' ),
				password: options.password || this.get( 'password' ),
			};
		
		$.ajax( {
			 url   : api.auth,
			 method: 'GET',
			 data  : data,
		 } )
		 .done( function ( response, textStatus, xhr ) {
			
			 // prepare customer for unit migration
			 let customer = response.customer;
			 customer.transientUsername = options.user,
				 customer.transientPassword = options.password,
				 delete customer.id;
			
			 self.set( {
				 user    : data.user,
				 password: data.password,
				 units   : new LegacyUnits( response.units ),
				 customer: new Customer( customer ),
			 } ).trigger( 'sync' );
		 } )
		 .fail( function ( response ) {
			 self.set( response.responseJSON );
			 self.trigger( 'error', self, response );
		 } );
	},
	
} );

export default LegacyUser;